import { Box } from "@mui/system";
import { DonutChart } from "bizcharts";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import DownloadButton from "../Common/DownloadButton";

const RingChart = (props) => {
  const [data, setData] = useState([]);

  const csv = props.csv;
  const { readString } = usePapaParse();

  const handleReadString = () => {
    readString(csv, {
      complete: (results, file) => {
        setData(results.data);
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };

  useEffect(() => {
    handleReadString();
  }, []);

  const [canvas, setCanvas] = useState(undefined);

  data.forEach((item, idx) => {
    // console.log(item);
    item["Proportion per food commodity"] =
      Math.round(item["Proportion per food commodity"] * 10) / 10;
  });
  // console.log(data);
  return (
    <Box
      display="flex"
      sx={{ maxWidth: "700px", width: "90%" }}
      flexDirection="column"
    >
      <Box display="flex" alignItems="center">
        <p
          className="titleChart"
          style={{
            width: "100%",
            marginBottom: "1.1rem",
            fontFamily: "Roboto Condensed, sans-serif",
          }}
        >
          Number of quantified residues per sample
        </p>
        <DownloadButton
          canvas={canvas}
          fileName="Number of quantified residues per sample"
          csv={data}
          isRaw
        />
      </Box>
      <DonutChart
        data={data.filter((d) => d["Food commodity"] === props.filter) || []}
        autoFit
        forceFit
        radius={0.8}
        interactions={[
          {
            type: "element-selected",
            enable: true,
          },
        ]}
        legend={{
          visible: false,
        }}
        label={{
          type: "outer",
          formatter: (angleField, colorField) => {
            return [
              "value",
              angleField["Number of quantifications"] +
                ":" +
                " " +
                angleField["EUCP samples"] +
                " (" +
                Math.round(angleField["Proportion per food commodity"] * 10) /
                  10 +
                "%)",
            ];
          },
          style: {
            fontFamily: "Roboto Condensed, sans-serif",
          },
        }}
        statistic={{
          title: false,
          content: false,
        }}
        tooltip={{
          itemTpl:
            '<li data-index={index} class="g2-tooltip-list-item" style="margin-bottom:3px;">' +
            '<span style="background-color:{color};width:10px;border-radius:50%;height:10px;display:inline-block;margin-right:8px;"></span>' +
            "{name}: {value}" +
            "%" +
            "</li>",

          containerTpl:
            '<div class="g2-tooltip"  id="tooltipWrap" >' +
            '<div class="g2-tooltip-title" id="tooltipTitle" style="font-weight:bold;font-size:medium;color:#22294d;">  </div>' +
            '<ul class="g2-tooltip-list " style="color:#22294d;"></ul>' +
            "</div>",
        }}
        padding="auto"
        angleField="Proportion per food commodity"
        colorField="Number of quantifications"
        color="#F9B112"
        pieStyle={{ stroke: "white", lineWidth: 1 }}
        onGetG2Instance={(chartInstance) => {
          setCanvas(chartInstance.chart.canvas);
        }}
      />
    </Box>
  );
};

export default RingChart;
